import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const app = firebase.initializeApp({
  // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APP_ID,

  apiKey: "AIzaSyBr2qgzKVDJxSr-ZctAb80_VNjX35lDNmM",
  authDomain: "sparrow-cap-auth-dev.firebaseapp.com",
  projectId: "sparrow-cap-auth-dev",
  storageBucket: "sparrow-cap-auth-dev.appspot.com",
  messagingSenderId: "817281347527",
  appId: "1:817281347527:web:597ba695d730ef6ff5b3e2",
});

const firestore = app.firestore();
export const database = {
  // folders: firestore.collection("folders"),
  files: firestore.collection("files"),
  formatDoc: (doc) => {
    return { id: doc.id, ...doc.data() };
  },
  getCurrentTimestamp: firebase.firestore.FieldValue.serverTimestamp,
};
export const storage = app.storage();
export const auth = app.auth();
export default app;
